module.exports = __webpack_public_path__ + "media/vo-thank-you.mp3";